import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { MIcon, Flex, Button, Text, Line, Hr, MobHide, Preloader } from './Uikit';
import { CSSgrid } from "./Catalog";
import { Appearer } from "./Appearer";
import uniqid from "uniqid";
import { Product } from "./Product";
import { StackInfo } from "./StackInfo";
import { getDataById, calculateTotal } from "./Utilities";
import { MetaContext } from "../context";
import { Select } from "./Uikit_select";
import { Svg } from "./Uikit_Svg";
import { StackExpanded, CSSstackModeBg } from './StackExpanded';
import { useToasts } from "react-toast-notifications";
import { Stack0 } from "./Stack0";

function StackInner({ stackMode, handleShown, history, match, location }) {
  const context = useContext(MetaContext);
  const { addToast } = useToasts();
  // const [stackShown, setStackShown] = useState(false);

  const handleStackShown = () => {
    // setStackShown(!stackMode);
    handleShown();
  };

  const codeStackToHash = (stackId) => {
    // history.push(`#${stack.map((id, i) => `${getDataById(context, id)['code']}`)}`)
    return `#${context.handles.getStack("title")}:${context.handles
      .getStack("stack")
      .map((id, i) => `${getDataById(context, id)["code"]}`)}`;
  };

  return (
    <>
      {context && (
        <CSSstack0 stackMode={location.pathname.includes("/stack")}>
          {!location.pathname.includes("/stack") && (
            <CSSopenStack to="/stack" />
          )}

<CSSbg />

<CSSstackInner>

<MobHide>
          <Line>
            <Text lg><h3>Stack</h3></Text>
          </Line>
          </MobHide>

          <CSSstackSelect>
            <Line lg>
              <Flex top>
                <div style={{ flexGrow: 1 }}>
                  <Select
                    colors={{
                      idle: `var(--main-bg-lighter-color)`,
                      accent: `var(--main-accent-color)`,
                      radius: "8px",
                    }}
                    // size="sm"
                    placeholder={
                      <Preloader width={24} height={24}/>
                    }
                    active={context.handles.getStack(false)["id"]}
                    menuHandler={(val) => {
                      if (val === 'create') {
                        context.handles.createStack();
                      } else {
                        context.handles.switchActiveStack(val);
                      }
                    }}
                    // help={<p><i>Pre-defined store configurations</i></p>}
                    options={[...context.handles.getAllStacks().map((oneStack) => ({
                      title: oneStack["title"],
                      value: oneStack["id"],
                    })), {
                      title: <>Create&nbsp;stack</>,
                      icon: <MIcon size={18}>add</MIcon>,
                      value: 'create',
                      separated: true,
                    }]}
                  />
                </div>
                &nbsp;
                <div style={{ flexGrow: 0 }}>
                  <Select
                    colors={{
                      idle: '#FFF',
                      accent: `var(--main-accent-color)`,
                      radius: "8px",
                    }}
                    dropIcon={false}
                    width={44}
                    dropLeft={true}
                    placeholder={<Svg width={24} height={24} />}
                    // active={null}
                    menuHandler={(val) => {
                      if (val === "clear") {
                        context.handles.setStack([]);
                      }
                      if (val === "duplicate") {
                        context.handles.duplicateStack();
                      }
                      if (val === "create") {
                        context.handles.createStack();
                      }
                      if (val === "delete") {
                        context.handles.deleteStack();
                      }
                      if (val === "share") {
                        navigator.clipboard.writeText(
                          `https://meta-nutrition.netlify.app/import${codeStackToHash()}`
                        );
                        addToast("Stack link copied to clipboard", {
                          appearance: "success",
                          autoDismiss: true,
                          autoDismissTimeout: 1000,
                        });
                      }
                    }}
                    // help={<p><i>Pre-defined store configurations</i></p>}
                    options={[
                      {
                        icon: <MIcon size={18}>clear</MIcon>,
                        title: "Clear",
                        value: "clear",
                      },
                      {
                        icon: <MIcon size={18}>delete</MIcon>,
                        title: "Delete",
                        value: "delete",
                      },
                      {
                        icon: <MIcon size={18}>content_copy</MIcon>,
                        title: "Duplicate",
                        value: "duplicate",
                      },
                      {
                        icon: <MIcon size={18}>share</MIcon>,
                        title: <>Copy&nbsp;stack&nbsp;URL</>,
                        value: "share",
                      },
                      {
                        icon: <MIcon size={18}>add</MIcon>,
                        title: <>Create&nbsp;stack</>,
                        value: "create",
                        separated: true,
                      },
                    ]}
                  />
                </div>
              </Flex>
            </Line>
          </CSSstackSelect>

          <Line lg>
            <CSSstackGrid>
              {context.handles.getStack().map((itm, i) => {
                let item = getDataById(context, itm["id"]);
                return (
                  <Appearer key={`product_stack_${item["name"]}}`} order={i}>
                    <Product
                      appearance="stack"
                      active={context["handles"].checkIfInStack(item["id"])}
                      handle={() => context["handles"].handleStack(item["id"])}
                      data={item}
                    />
                  </Appearer>
                );
              })}

            </CSSstackGrid>
          </Line>

          {/* {Boolean(context.handles.getStack().length) && <StackInfo />} */}

          {Boolean(context.handles.getStack().length) && (
            <CSScart0>
              {/* <MobHide> */}
                <Flex vertical>
                  {/* <span>
                    <h4>€&thinsp;{calculateTotal(context)}</h4>
                  </span> */}
                  <Link to="/stack">
                    <Button onClick={() => handleStackShown()}>
                      <MIcon size={20} left>fullscreen</MIcon>See my stack
                    </Button>
                  </Link>
                </Flex>
              {/* </MobHide> */}
            </CSScart0>
          )}

{context.handles.getStack().length < 3 && (
                <>
                  <CSSquizQuestion>
                    <Flex vertical center>
                      {!context.handles.getStack().length && <Line>
                        <h3>
                          <Text center>
                            Need help
                            <br />
                            with your stack?
                          </Text>
                        </h3>
                      </Line>}
                      <Line>
                        <Link to="/quiz">
                          <Button flat={context.handles.getStack().length > 0 ? true : false}>&nbsp;&nbsp;Take a quiz!&nbsp;&nbsp;</Button>
                        </Link>
                      </Line>
                    </Flex>
                  </CSSquizQuestion>
                </>
              )}

</CSSstackInner>

        </CSSstack0>
      )}

    </>
  );
}

const CSSstackInner = styled.div`
  padding: 1em 2em 0em 2em;
  position: relative;
  z-index: 1;
  @media (max-width: 991px) {
    padding: 0em 0em 0em 0em;
  }
`


const CSSbg = styled.div`
    position: absolute;
    left: 1em;
    right: 1em;
    top: 0;
    bottom: 0;
    background-color: white;
    border-radius: 1em;
    z-index: 0;
    box-shadow: 0px 14px 30px -10px rgba(0, 0, 0, 0.1);

  @media (max-width: 991px) {
    background-color: white;
    box-shadow: 0px 4px 20px -14px rgba(0, 0, 0, 1);
  }
`

const CSSopenStack = styled(Link)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: rgba(255, 255, 255, 0.01);
  display: none;
  @media (max-width: 991px) {
    display: block;
  }
`;

const CSSstackSelect = styled.div`
  position: relative;
  z-index: 2;
  @media (max-width: 991px) {
    display: none;
  }
`;

const CSSstack0 = styled.div`
  position: relative;
  @media (max-width: 991px) {
    padding: 1em 1em 0.01em 1em;
    margin: 0 0 0em 0;
    ${({ stackMode }) => stackMode && css`
        padding: 0;
      `}
  }
`;

const CSSstackGrid = styled.div`
  display: grid;
  grid-row-gap: 0.6em;
  @media (max-width: 991px) {
    margin: 0 0 0 1em;
    width: 100%;
    overflow: hidden;
    display: flex;
  }
`;

const CSScart0 = styled.div`
  z-index: 1;
  /* height: 8em; */
  padding: 1em 0;
  display: flex;
  align-items: center;
  position: ${({ unstick }) => (unstick ? "relative" : "sticky")};
  bottom: 0px;
  display: flex;
  justify-content: center;
  background: transparent;
  /* background: linear-gradient(
    0deg,
    var(--main-bg-darker-color) 42%,
    rgba(255, 255, 255, 0) 100%
  ); */
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 42%,
    rgba(255, 255, 255, 0) 100%
  );
  @media (max-width: 991px) {
    /* height: auto; */
    display: none;
  }
`;

const CSSquizQuestion = styled.div`
  /* background-color: var(--main-bg-lighter-color); */
  /* border-radius: 1.4em; */
  /* border: 1px solid var(--main-border-color); */
  /* border-top: 2px solid var(--main-bg-color); */
  /* border-bottom: 2px solid var(--main-bg-color); */
  margin: 0em 0 1em 0;
  padding: 0 1em 0 1em;
  @media (max-width: 991px) {
    display: none;
  }
`;

export const Stack = withRouter(StackInner);
